import axios from 'axios';

export type StopQueryConfig = {
  stopStatusCodes?: number[];
  stopErrorMessages?: string[];
  customValidation?: (error: unknown) => boolean;
};

const defaultConfig: StopQueryConfig = {
  stopStatusCodes: [403, 404, 401],
};

export const queryStop = (error: unknown, config: StopQueryConfig = defaultConfig): boolean => {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    const message = error.response?.data?.message;

    if (status === undefined || message === undefined) {
      return false;
    }

    if (config.stopStatusCodes?.includes(status)) {
      return true;
    }

    if (config.stopErrorMessages?.includes(message)) {
      return true;
    }
  }

  if (config.customValidation) {
    return config.customValidation(error);
  }

  return false;
};
